{
  "ChangeUserAgent_Title": "Browserweergaveprofiel instellen",
  "ChangeUserAgent_SubTitle": "Selecteer het browserweergaveprofiel waarmee u de inhoud van de webpagina's wilt weergeven binnen uw huidige websessie op deze computer.",
  "ChangeUserAgent_FieldName_BrowserProfile": "Browserprofiel",
  "ChangeUserAgent_Options_ForceAutomaticBrowserDetection": "[Automatische browserdetectie forceren]",
  "ChangeUserAgent_FooterActions_Apply": "Toepassen",
  "ChangeUserAgent_FooterActions_Cancel": "Annuleren",
  "NAME": "ChangeUserAgentLanguage"
}